import { ClientLogo } from "@/components/ClientLogo";
import { LoginParticlesBackground } from "@/components/auth/LoginParticlesBackground";
import { activateLoginSurface } from "@/lib/routeSurface";
import { Eye, EyeOff, Loader2 } from "lucide-react";
import { useEffect, useState } from "react";

export type LoginScreenProps = {
  title?: string;
  error?: string | null;
  loading?: boolean;
  onSubmit: (username: string, password: string) => void | Promise<void>;
};

export function LoginScreen({
  title = "Faça login para acessar sua conta",
  error = null,
  loading = false,
  onSubmit,
}: LoginScreenProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    return activateLoginSurface();
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    void onSubmit(username, password);
  };

  return (
    <div className="login-page">
      <LoginParticlesBackground />
      <div className="login-card">
        <div className="login-card-glow login-card-glow-1" aria-hidden />
        <div className="login-card-glow login-card-glow-2" aria-hidden />
        <div className="login-card-content">
          <ClientLogo variant="login" className="login-logo" />
          <h1 className="login-title">{title}</h1>
          <form onSubmit={handleSubmit} className="login-form">
            <div>
              <label htmlFor="login-username" className="login-field-label">
                Usuário
              </label>
              <input
                id="login-username"
                name="username"
                className="login-input"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div>
              <label htmlFor="login-password" className="login-field-label">
                Senha
              </label>
              <div className="login-password-wrap">
                <input
                  id="login-password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  className="login-input login-input--password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  tabIndex={-1}
                  className="login-password-toggle"
                  aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                  onClick={() => setShowPassword((v) => !v)}
                >
                  {showPassword ? (
                    <EyeOff className="h-4 w-4" aria-hidden />
                  ) : (
                    <Eye className="h-4 w-4" aria-hidden />
                  )}
                </button>
              </div>
            </div>
            {error ? <p className="login-error">{error}</p> : null}
            <button type="submit" className="login-button" disabled={loading}>
              {loading ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
                  Entrando...
                </>
              ) : (
                "Entrar"
              )}
            </button>
          </form>
          <p className="login-legal">
            Ao criar ou acessar sua conta, você está de acordo com os{" "}
            <a
              href="https://grandsystem.com.br/termos-de-uso/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Termos de Uso
            </a>{" "}
            e ciente da{" "}
            <a
              href="https://grandsystem.com.br/politicas-de-privacidade/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Política de Privacidade
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
